import { ReactNode, useEffect, useState } from 'react'
import { Box, Flex } from 'theme-ui'
import ReactInputVerificationCode from 'react-input-verification-code'
import { Loading } from 'components'
import { ErrorMessage } from 'components/Form'

export type VerificationFormValues = {
  code: string
}

export type VerificationCodeFormProps = {
  loading?: boolean
  isCodeInvalid?: boolean
  invalidCodeMessage?: ReactNode | null
  onSubmit: (values: VerificationFormValues) => void
}

export function VerificationCodeForm({
  loading = false,
  isCodeInvalid = false,
  invalidCodeMessage = null,
  onSubmit,
}: VerificationCodeFormProps) {
  const codeLength = 4
  const [code, setCode] = useState('')

  useEffect(() => {
    if (code.length >= codeLength) {
      onSubmit({ code })
      setCode('')
    }
  }, [code, onSubmit, setCode])

  const handleSubmit = (evt: any) => {
    evt.preventDefault()
    onSubmit({ code })
  }
  return (
    <Box py={4} sx={{ width: 300 }}>
      <form onSubmit={handleSubmit}>
        <Flex
          mx="auto"
          sx={{ mt: 4, mb: 3, alignItems: 'center', justifyContent: 'center' }}>
          <div className="VerificationCode">
            {!loading ? (
              <ReactInputVerificationCode
                autoFocus
                length={4}
                placeholder=""
                value={code}
                onChange={(value) => setCode(value.substring(0, codeLength))}
              />
            ) : (
              <Loading />
            )}
          </div>
        </Flex>
        {isCodeInvalid && !loading && (
          <Box>
            <ErrorMessage>{invalidCodeMessage}</ErrorMessage>
          </Box>
        )}
      </form>
    </Box>
  )
}
